import React, { useContext, useState, useEffect } from 'react';
import { SearchContext } from './index';
import { Row } from 'react-bootstrap';
import Link from 'next/link';
import { useService } from 'hooks/useService';
import { formatApiObj } from 'helpers/auctions';
import { randomString } from 'helpers/string';
import { Loading } from '../../Loading';

const AuctionsByState = ({title, state, setLoadingCity}) => {
    const {makeApiObj, searchState: {search_obj, active_tab}} = useContext(SearchContext);
    const [cities, setCities] = useState([]);
    const [{ data: {metrics}, loading }, fireGetMetrics] = useService();

    useEffect(() => {
        fireGetMetrics({
            url: `/services/reports/auction-metrics/${active_tab}/state/cities`,
            params: {
                ...formatApiObj(makeApiObj(search_obj)),
                randStr: randomString(),
            },
        });
    }, [active_tab]);

    const splitArray = (array) => {
        const result = [];
        const length = array?.length;
        const size = Math.floor(length / 3);
        const remainder = length % 3;
        let i = 0;
        for (let j = 0; j < 3; j++) {
            let _size = size;
            if (j < remainder) {
                _size++;
            }
            result.push(array?.slice(i, i + _size));
            i += _size;
        }

        setCities(result);
    };

    useEffect(() => {
        if (metrics?.cities?.length) splitArray(metrics?.cities);
    }, [metrics?.cities?.length]);

    if (loading) {
        setLoadingCity(true);
        return <Loading />;
    }else{
        setLoadingCity(false);
    }

    return metrics?.cities?.length > 0 ? (
        <>
            <Row>
                <div className="filter-title filter-title-first">
                    {title}
                </div>
            </Row>
            <Row
                className="padding15"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                {cities.map(a => (
                    <div key={a} style={{flex: '33.3%'}}>
                        {a.map(c =>
                            <div key={c}>
                                <Link
                                    href={`/auctions/${state}/${c.substring(0, c.indexOf('(')).toLowerCase()}`}
                                >
                                    {c}
                                </Link>
                            </div>,
                        )}
                    </div>
                ))}
            </Row>
        </>
    ) : null;
};

AuctionsByState.displayName = 'AuctionsByState';

export default AuctionsByState;